"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  height: 100%;\n  width: 100%;\n\n  .title {\n    text-align: center;\n    font-feature-settings: \"pnum\" on, \"lnum\" on;\n    h2 {\n      margin: auto;\n    }\n  }\n  .general-text {\n    text-align: center;\n    font-feature-settings: \"pnum\" on, \"lnum\" on;\n    p {\n      color: ", ";\n      font-family: ", ";\n      font-size: 14px;\n      margin: auto;\n    }\n  }\n"])), _variables.GlobalColors.s4, _variables.FontFamily.AvenirNext);

exports.Container = Container;